// SCRUM-453: the event form's Operators field — pure list helpers.
// An operator is { userId, email, fullName } as the API returns it.

/** Trimmed, lower-cased email ("" for anything that isn't a string). */
export const normalizeEmail = (email) =>
    typeof email === "string" ? email.trim().toLowerCase() : "";

const sameOperator = (a, b) =>
    (a.userId && a.userId === b.userId) ||
    (normalizeEmail(a.email) !== "" && normalizeEmail(a.email) === normalizeEmail(b.email));

/** The list with `operator` appended, unless it is already on it. */
export const addOperator = (list, operator) =>
    list.some((o) => sameOperator(o, operator)) ? list : [...list, operator];

/** The list without the operator for this userId. */
export const removeOperator = (list, userId) => list.filter((o) => o.userId !== userId);

/** True when an email typed in the box is already a chip. */
export const hasOperatorEmail = (list, email) =>
    list.some((o) => normalizeEmail(o.email) === normalizeEmail(email));

/** Chip text: "Full Name · email" (just the email when there is no name). */
export const operatorLabel = (o) => (o.fullName ? `${o.fullName} · ${o.email}` : o.email);

/** The emails the PUT sends. */
export const operatorEmails = (list) => list.map((o) => normalizeEmail(o.email)).filter(Boolean);
